<div class="search-result" [ngClass]="backgroundClass">
    <div class="result-header">
        <div class="result-type-badge customer">
            <mat-icon>people</mat-icon>
            <span class="badge-label">Customer</span>
        </div>
        <div class="action-buttons" (click)="$event.stopPropagation()">
            <button
                matMiniFab
                color="primary"
                class="d-none d-lg-block"
                (click)="$event.stopPropagation(); gridButton()"
                [routerLink]="'datamaintenance/customers'"
                [queryParams]="{ ID: item().ID }"
                matTooltip="Customer Grid">
                <mat-icon class="no-margin">people</mat-icon>
            </button>
            <button
                matMiniFab
                color="primary"
                class="d-none d-lg-block"
                (click)="contactButton()"
                matTooltip="Customer Contacts">
                <mat-icon class="no-margin">person_add</mat-icon>
            </button>

            <button
                matMiniFab
                color="primary"
                class="d-block d-lg-none"
                aria-label="toggle customer menu button"
                [matMenuTriggerFor]="customerMenu">
                <mat-icon class="no-margin">menu</mat-icon>
            </button>
        </div>
        @if (customerStatus.text) {
            <div class="status-badge" [ngClass]="'status-' + customerStatus.level">
                {{ customerStatus.text }}
            </div>
        }
    </div>

    <div class="result-primary">
        <div class="result-id" [highlight]="searchTerm()">{{ primaryId }}</div>
    </div>

    <div class="result-details">
        @if (fullAddress) {
            <div class="detail-row">
                <div class="detail-item">
                    <mat-icon class="detail-icon text-muted">place</mat-icon>
                    <span class="detail-value" [highlight]="searchTerm()">{{ fullAddress }}</span>
                </div>
            </div>
        }

        <div class="detail-grid credit-info">
            <div class="detail-item">
                <span>
                    <mat-icon class="detail-icon text-muted">attach_money</mat-icon>
                    <span class="detail-label text-muted">Credit:</span>
                </span>
                <span class="detail-value">{{ formatCurrency(item().Credit) }}</span>
            </div>
            <div class="detail-item">
                <span class="detail-label text-muted">Limit:</span>
                <span class="detail-value">{{ formatCurrency(item().CreditLimit) }}</span>
            </div>
        </div>
    </div>
</div>

<mat-menu #customerMenu="matMenu" xPosition="before">
    <div class="d-flex flex-column">
        <button
            mat-menu-item
            class="d-flex align-items-center"
            (click)="gridButton()"
            [routerLink]="'datamaintenance/customers'"
            [queryParams]="{ ID: item().ID }">
            <mat-icon color="primary">people</mat-icon>
            <span>Customer Grid</span>
        </button>
        <button mat-menu-item class="d-flex align-items-center" (click)="contactButton()">
            <mat-icon color="primary">person_add</mat-icon>
            <span>Customer Contacts</span>
        </button>
    </div>
</mat-menu>
